<template>
	<div class="overlay">
		<circle-9></circle-9>
	</div>
</template>

<script>
	import {Circle9} from 'vue-loading-spinner'

	export default {
		name: "UploadSpinner",
		components: {
			Circle9
		}
	}
</script>

<style scoped>

	.overlay {
		z-index: 999;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.6);
		position: absolute;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
</style>